<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="文件名称">
                  <el-input style="width: 177px" v-model="queryForm.fileName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseMerterialList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseMerterial"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduCourseMerterial(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseMerterial(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportEduCourseMerterialList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshEduCourseMerterialList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseMerterialList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fileName"
        label="文件名称"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fileUrl"
        label="文件URL"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="fileTag"
        label="文件标签"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkEduCourseMerterial(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduCourseMerterial(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduCourseMerterial(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseMerterialStates[eduCourseMerterialState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="eduCourseMerterial"
          ref="eduCourseMerterialForm"
          :rules="rules"
          label-width="80px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="文件名称"
            prop="fileName"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseMerterial.fileName"
              :disabled="eduCourseMerterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="文件URL"
            prop="fileUrl"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseMerterial.fileUrl"-->
<!--              :disabled="eduCourseMerterialState == 'check'"-->
<!--            ></el-input>-->
              <div style="width: 177px;display: flex;align-items: center;">
                  <el-input v-model="eduCourseMerterial.fileUrl" size="small" :disabled="eduCourseMerterialState == 'check'"></el-input>
                  <el-button type="primary" size="small" style="margin-left: 2px;" @click="uploadImages1()" :disabled="eduCourseMerterialState == 'check'">上传文件
                      <el-upload action="#" :headers="header" v-show="false" ref="uploads1" class="avatar-uploader" :show-file-list="false"
                                 :http-request="uploadImage1">
                          <el-button type="primary" size="small" class="as1">上传</el-button>
                      </el-upload>
                  </el-button>
              </div>
          </el-form-item>
          <el-form-item
            label="文件标签"
            prop="fileTag"
          >
            <el-input
              size="small"
              style="width: 177px"
              v-model="eduCourseMerterial.fileTag"
              :disabled="eduCourseMerterialState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseMerterial.sort"-->
<!--              :disabled="eduCourseMerterialState == 'check'"-->
<!--            ></el-input>-->
              <el-input-number
                  style="width: 177px"
                  :disabled="eduCourseMerterialState == 'check'"
                  v-model="eduCourseMerterial.sort"
                  size="small"
                  label=""
                  :min="1"
                  :max="100000"
                  :step="1"
                  :controls="true"
                  controls-position="both"
              >
              </el-input-number>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseMerterialState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import { UPLOAD_API, UPLOAD_PATH } from '@/utils/constant';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseMerterialList();
                    this.getEduCourseMerterialList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseMerterialList();
                    this.getEduCourseMerterialList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     fileName: '', //文件名称
                     fileUrl: '', //文件URL
                     fileTag: '', //文件标签
                     sort: '', //排序
                },
                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseMerterialState: 'add',
                eduCourseMerterialStates: {
                    add: '新建文件',
                    check: '查看文件',
                    edit: '修改文件'
                },

                multipleSelection: [],
                eduCourseMerterialList: [],
                eduCourseMerterial: {
                    id: '', //
                    fileName: '', //文件名称
                    fileUrl: '', //文件URL
                    fileTag: '', //文件标签
                    sort: '', //排序
                },
                btnLoading: false,

                rules: {
                    fileName: [{ required: true, message: '文件名称不能为空', trigger: 'blur' }],
                    fileUrl: [{ required: true, message: '文件URL不能为空', trigger: 'blur' }],
                    fileTag: [{ required: true, message: '文件标签不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getEduCourseMerterialList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            uploadImages1() {
                this.$refs.uploads1.$el.querySelector(".as1").click()
            },
            uploadImage1(params) {
                const file = params.file;
                const formData = new FormData();
                formData.append('file', file);
                upload('/mpp/file/upload', formData).then((res) => {
                    if (res.success) {
                        this.eduCourseMerterial.fileUrl = res.url
                    }else{
                        this.$message.error(res.msg)
                    }
                });
            },
            resetEduCourseMerterialList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseMerterialList = [];
            },
            resetDialog() {
                this.eduCourseMerterialState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      fileName: '', //文件名称
                      fileUrl: '', //文件URL
                      fileTag: '', //文件标签
                      sort: '', //排序
                };
                this.getEduCourseMerterialList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseMerterial = {
                      id: '', //
                      fileName: '', //文件名称
                      fileUrl: '', //文件URL
                      fileTag: '', //文件标签
                      sort: '', //排序
                };
            },
            submitForm() {
                if (this.eduCourseMerterialState == 'add') {
                    this.$refs.eduCourseMerterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursemerterial/add`,{ ...this.eduCourseMerterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseMerterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseMerterialState == 'edit') {
                    this.$refs.eduCourseMerterialForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursemerterial/edit`,{ ...this.eduCourseMerterial }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseMerterialList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseMerterial() {
                this.showDialog = true;
                this.eduCourseMerterialState = 'add';
            },
            checkEduCourseMerterial(eduCourseMerterialId) {
                console.log(eduCourseMerterialId);
                this.currentEduCourseMerterialId = eduCourseMerterialId;

                this.getEduCourseMerterialById();
                this.showDialog = true;
                this.eduCourseMerterialState = 'check';
            },
            editEduCourseMerterial(eduCourseMerterialId) {
                console.log('eduCourseMerterial', eduCourseMerterialId);
                if (eduCourseMerterialId) {
                    this.currentEduCourseMerterialId = eduCourseMerterialId;
                    this.getEduCourseMerterialById();
                } else {
                    this.eduCourseMerterial = { ...this.eduCourseMerterial, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseMerterialState = 'edit';
            },
            deleteEduCourseMerterial(eduCourseMerterialId) {
                let ids = '';
                if (eduCourseMerterialId) {
                    ids = eduCourseMerterialId;
                } else {
                    ids = this.multipleSelection.map((eduCourseMerterial) => eduCourseMerterial.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursemerterial/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseMerterialList();
                                this.getEduCourseMerterialList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseMerterialList() {
                this.resetEduCourseMerterialList();
                this.getEduCourseMerterialList();
            },
            getEduCourseMerterialList(query = {}) {
                this.loading = true;
                get(`/edu/coursemerterial/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseMerterialList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseMerterialById() {
                get(`/edu/coursemerterial/get`,{ id: this.currentEduCourseMerterialId }).then((res) =>{
                    if(res.success){
                      this.eduCourseMerterial = { ...this.eduCourseMerterial, ...res.eduCourseMerterial };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseMerterialList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursemerterial/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursemerterial/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursemerterial/importData`,formData);
              this.refreshEduCourseMerterialList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseMerterialList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseMerterialList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>